<div class="page">
  <div class="top">
    <div class="slot topSlot">
      <div class="topSlot"> <ng-content></ng-content> </div>
    </div>
    <div class="slot headerSlot">
      <ng-container class="headerSlot"> <ng-content></ng-content> </ng-container>
    </div>
    <div class="slot bannerSlot">
      <ng-container class="bannerSlot"> <ng-content></ng-content> </ng-container>
    </div>
    <div class="slot subHeaderSlot">
      <ng-container class="subHeaderSlot"> <ng-content></ng-content> </ng-container>
    </div>
    <div class="slot mainSlot">
      <ng-container class="stepAddressSlot"> <ng-content></ng-content> </ng-container>
      <ng-container class="stepDeliverySlot"> <ng-content></ng-content> </ng-container>
      <ng-container class="stepPaymentSlot"> <ng-content></ng-content> </ng-container>
      <ng-container class="stepSummarySlot"> <ng-content></ng-content> </ng-container>
      <ng-container class="mainSlot"> <ng-content></ng-content> </ng-container>
      <ng-container class="mainSlotRight"> <ng-content></ng-content> </ng-container>
      <ng-container class="mainSlotLeft"> <ng-content></ng-content> </ng-container>
    </div>
  </div>
  <div class="bottom">
    <div class="slot subFooterSlot">
      <ng-container class="subFooterSlot"> <ng-content></ng-content> </ng-container>
    </div>
    <div class="slot footerSlot">
      <ng-container class="footerSlot"> <ng-content></ng-content> </ng-container>
    </div>
    <div class="slot bottomSlot">
      <ng-container class="bottomSlot"> <ng-content></ng-content> </ng-container>
    </div>
  </div>
</div>
